import { Pipe, PipeTransform } from '@angular/core';
import { CurrencyPipe } from '@angular/common';
import { CultureService } from '../../public-api';

@Pipe({ name: 'localCurrency', standalone: false })
export class localCurrencyPipe implements PipeTransform {
  
  constructor(
      private cultureService: CultureService
    ) {}

  transform(value: number | string): string {
    return this.cultureService.formatCurrency(value);
  }
}
